import React from "react";
import { useDataLoader, LoadingRegion, Stack, HoverRegion, PullRight } from "@optimed/react";
import { syncService, mappingService } from "../api";
import { Panel, PanelBody, Button, toast, Badge, Text } from "@optimed/react";
import { Identifier } from "./Identifier";
import { ValidationView } from "./ValidationView";
import { modelValidator } from "./modelValidator";
import { ServiceMapping, HisService } from "../api/models";
import { serviceMappingDialog } from "./ServiceMappingDialog";
import { DoctorDocplannerLabel } from "./DoctorDocplannerLabel";
import { AddressLabel } from "./AddressLabel";
import { ServiceName } from "./ServiceName";

export function ServicesPanel() {
  const [services, loading, refreshServices] = useDataLoader(() => {
    return syncService.services();
  });

  function setMapping(service: ServiceMapping) {
    if (!service.his) return;

    serviceMappingDialog
      .open({
        hisService: service.his,
      })
      .onResult(() => refreshServices(true));
  }

  function removeMapping(service: ServiceMapping) {
    mappingService.deleteService({ mappingId: service.mappingId }).then(
      () => refreshServices(),
      () => toast.error("Wystąpił błąd podczas usuwania mapowania")
    );
  }

  return (
    <Panel>
      <PanelBody>
        <LoadingRegion promise={loading}>
          <Stack>
            {services?.map(x => (
              <HoverRegion key={x.docplanner?.id}>
                <div>
                  <div>
                    <HoverRegion.WhenHover>
                      <PullRight>
                        <span>
                          {x.mappingId ? (
                            <span>
                              <Button size="sm" text="Ustaw dodatkowe mapowanie" onClick={() => setMapping(x)} />
                              <Button size="sm" color="danger" text="Usuń mapowanie" onClick={() => removeMapping(x)} />
                            </span>
                          ) : (
                            <Button size="sm" text="Ustaw mapowanie" onClick={() => setMapping(x)} />
                          )}
                        </span>
                      </PullRight>
                    </HoverRegion.WhenHover>
                    <div>
                      <span>
                        {x.his?.nazwa} <Identifier value={x.his?.id} title="Optimed NXT" />
                      </span>
                      <span hidden={!x.docplanner && !x.docplannerAddressService}>
                        {" / "}
                        <ServiceName addressService={x.docplannerAddressService} service={x.docplanner} />{" "}
                        <Identifier value={x.docplanner?.id} title="Znany Lekarz" />{" "}
                        <Identifier value={x.docplannerAddressService?.id} title="Znany Lekarz (address service)" />{" "}
                        <Badge
                          type="info"
                          hidden={!x.docplannerAddressService}
                          title="Dotyczy tylko procedury dla jednego konkretnego lekarza w portalu Znany Lekarz"
                        >
                          Powiązane z lekarzem
                        </Badge>
                      </span>
                    </div>
                    <Text small>
                      <div>Kod wewnętrzny: {x.his?.kod}</div>
                      <div hidden={!x.docplannerDoctor}>
                        <span>Lekarz: </span>
                        <DoctorDocplannerLabel doctor={x.docplannerDoctor} />{" "}
                        <AddressLabel address={x.docplannerDoctor?.address} />
                      </div>
                    </Text>
                  </div>
                  <ValidationView validations={modelValidator.checkServiceMapping(x)} />
                </div>
              </HoverRegion>
            ))}
          </Stack>
        </LoadingRegion>
      </PanelBody>
    </Panel>
  );
}
